import { Card, Row, Timeline } from "antd"
import { FC, useState } from "react"
import { StyleUtils } from "../../../utils/Style"
import { AntdCard, AppMainText } from "../../../views/commonview"
import '../index.css';
import { AppEvent } from "../../../data/events"
import events, { useEventBus } from "../../../utils/events"
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { cb as dark, base16AteliersulphurpoolLight as light, } from 'react-syntax-highlighter/dist/esm/styles/prism'
import { GlobalUtil } from "../../../utils/GlobalText";
import { UserInfoManager } from "../../../utils/UserInfoManager";
import { GITHUB_LINKS, getCoinConfig } from "../../../utils/CoinConfig";


function HelpDoc() {
    const config = getCoinConfig(UserInfoManager.getCurrency());
    const currency = UserInfoManager.getCurrency();

    return (
        `* ${GlobalUtil.t("miner_help.parmas_desc")}
    ~~~shell

    USAGE:
        ${config.prover} [FLAGS] [OPTIONS]

    FLAGS:
        -h, --help
                Prints help information

        -V, --version
                Prints version information
    OPTIONS:
        -p, --pool <pool>
                Format: <working protocol>+<transport protocol>://<pool>:<port> Working protocol: stratum
                Transport protocols: tcp, ssl

        -w, --worker <worker>
                Sets the worker name [default: accountName.minerName]
    ~~~

* ${GlobalUtil.t("miner_help.start")}
    ~~~shell
    # ${GlobalUtil.t("miner_help.set")}
    chmod +x ${config.prover}

    # ${GlobalUtil.t("miner_help.start_command")}
    1.accountName + "." + minerName
    ./${config.prover} -w <accountName>.<minerName> -p stratum+tcp://${currency}.drpool.io:${config.port}

    ~~~
`
    );
}

export const NockGuidePage: FC = () => {
    return (
        <>
            <Row justify={"center"} style={{ color: StyleUtils.theme().fontColor_1, fontSize: "2.4rem", alignItems: "center", marginTop: StyleUtils.getWidth(36), marginBottom: StyleUtils.getWidth(18) }}>
                <div style={{ fontWeight: "500" }}>

                    <AppMainText text={GlobalUtil.t("miner_help.miner_help")} />
                </div>
            </Row>
            <Timeline className="tml"
                style={{ marginBottom: '64px' }}
                items={[
                    {
                        children: <AntdCard><Card>
                            <div style={{ ...StyleUtils.fontStyle_2(), fontSize: StyleUtils.getFont(14) }}>{GlobalUtil.t("miner_help.prepare")}</div>
                            <div style={{ ...StyleUtils.fontStyle_3() }}>
                                <p> {GlobalUtil.t("miner_help.system")} {GlobalUtil.t("miner_help.system_desc")}</p>
                                {/* TODO: 下载地址缺失 */}
                                <p> {GlobalUtil.t("miner_help.software")} <a href={GITHUB_LINKS[UserInfoManager.getCurrency() as keyof typeof GITHUB_LINKS] || GITHUB_LINKS.neptune} target="_blank">{GlobalUtil.t("miner_help.software_download")}</a></p>
                            </div>
                        </Card>
                        </AntdCard>
                    },
                    {
                        children: <AntdCard><Card>
                            <div style={{ ...StyleUtils.fontStyle_2(), fontSize: StyleUtils.getFont(14) }}>{GlobalUtil.t("miner_help.regist")}</div>
                            <div style={{ ...StyleUtils.fontStyle_3() }}>
                                <p>{GlobalUtil.t("miner_help.regist_desc")}</p>
                            </div>
                        </Card>
                        </AntdCard>
                    },
                    {
                        children: <AntdCard><Card>
                            <div style={{ ...StyleUtils.fontStyle_2(), fontSize: StyleUtils.getFont(14) }}>{GlobalUtil.t("miner_help.start_and_set")}</div>
                            <div style={{ ...StyleUtils.fontStyle_3() }}>
                                <p></p>

                                <ReactMarkdown
                                    className=""
                                    children={String(HelpDoc())}
                                    components={{
                                        code({ node, inline, className, children, ...props }) {
                                            const match = /language-(\w+)/.exec(className || '')
                                            return (
                                                !inline && match ?
                                                    <SyntaxHighlighter
                                                        {...props}
                                                        customStyle={{
                                                            fontSize: StyleUtils.getFont(14),
                                                            padding: "8px 16px",
                                                            borderRadius: '.5rem'
                                                        }}
                                                        children={String(children).replace(/\n$/, '')}
                                                        style={StyleUtils.isLight ? dark : light}
                                                        language={match[1]}
                                                        PreTag={"div"}
                                                    />
                                                    :
                                                    <code {...props} style={{ fontSize: StyleUtils.getFont(0.88) }} className={className}>
                                                        {children}
                                                    </code>
                                            )
                                        }
                                    }}
                                />


                            </div>
                        </Card >
                        </AntdCard >
                    },
                ]}
            />

        </>
    )
}